var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEclipseDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2255",
    d: "M83.0442 153.434H52.3774C56.4379 167.363 63.9727 179.848 75.0039 190.879C92.59 208.469 113.737 217.249 138.465 217.249C143.409 217.249 148.198 216.881 152.85 216.18C171.477 213.368 187.784 204.947 201.757 190.879C212.859 179.852 220.447 167.363 224.539 153.434H212.094H193.896H83.0442Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2255",
    d: "M66.1338 111.782H50.1137C49.5276 115.302 49.1283 118.896 48.947 122.581H67.9873H77.5386H215.405H227.989C227.806 118.896 227.407 115.302 226.815 111.782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2255",
    d: "M48.947 132.609C49.1283 136.295 49.5258 139.889 50.1137 143.407H66.7694H79.3939H214.281H226.819C227.409 139.889 227.812 136.295 227.995 132.609"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2255",
    d: "M224.542 101.753C220.454 87.7855 212.864 75.2434 201.756 64.1335C187.82 50.1994 171.559 41.8367 152.993 39.0236C148.297 38.3111 143.46 37.9375 138.465 37.9375C113.736 37.9375 92.5878 46.672 75.0035 64.1335C63.9687 75.2434 56.4302 87.7855 52.3716 101.753"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "M43.6227 127.597C43.6227 80.3004 79.1448 41.0018 125.355 34.0897C124.209 34.0476 123.057 34 121.899 34C70.0422 34 28 75.9067 28 127.597C28 179.29 70.0403 221.193 121.899 221.193C123.061 221.193 124.213 221.15 125.363 221.106C79.1448 214.194 43.6227 174.896 43.6227 127.597Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_159_844)",
    d: "M199.398 122.579C199.097 118.878 198.475 115.268 197.544 111.781H79.3939C78.4635 115.264 77.8389 118.876 77.5386 122.579H199.398Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_159_844)",
    d: "M199.398 132.609H77.5403C77.8406 136.31 78.4615 139.918 79.3938 143.407H197.546C198.476 139.92 199.097 136.31 199.398 132.609Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_159_844)",
    d: "M138.469 188.748C163.006 188.748 184.156 174.291 193.896 153.434H83.0425C92.7824 174.291 113.933 188.748 138.469 188.748Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.509 132.608H77.4541H199.626H215.676H227.868C227.952 131.013 228 129.407 228 127.788C228 126.039 227.936 124.306 227.837 122.577H215.674H199.625H77.4522H67.8753H48.9467C48.8478 124.302 48.7837 126.039 48.7837 127.788C48.7837 129.407 48.8313 131.013 48.9156 132.608H68.509Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.685 101.753H52.3699C51.3736 105.018 50.7307 108.368 50.1135 111.784H65.7271H79.022H197.482H214.258H226.249C225.63 108.372 224.834 105.022 223.839 101.753"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.733 143.405H197.956H79.4983H66.839H50.1118C50.7125 146.817 51.3957 150.165 52.3756 153.434H83.1576H194.297H212.542H224.425C225.403 150.168 226.193 146.82 226.795 143.405H214.733Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_844",
    x1: 138.467,
    x2: 138.467,
    y1: 229.42,
    y2: 94.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#473788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#2C2255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_844",
    x1: 138.468,
    x2: 138.468,
    y1: 229.422,
    y2: 94.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#473788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#2C2255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_844",
    x1: 138.469,
    x2: 138.469,
    y1: 229.417,
    y2: 94.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#473788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#2C2255"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseDark);
export default __webpack_public_path__ + "static/media/Eclipse-Dark.aa2f92d16b94d360b57e06ba21159a6b.svg";
export { ForwardRef as ReactComponent };